import MainTracker from "./trackers/mainTracker";
import Analytics from "./analytics";

export function init(trackers) {
  const tracker = new MainTracker(trackers);
  Analytics.setConfig({tracker});
  Analytics.identify();
}
